const paymentMethodTypes = {
  CARD: 'card',
  BANK_ACCOUNT: 'bankAccount',
};

export default paymentMethodTypes;
